



















import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
// import {AuditUserLogType} from "@/api/appService";

@Component({
  name: "AuditTabOfExternalProjectSummaryReport",
  components: { AuditTabPane },
})
export default class AuditTabOfExternalProjectSummaryReport extends Vue {
  get fetchData() {
    return api.externalProjectSummaryReport.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "externalProjectSummaryReportDetail",
      params: { id: dto.id!.toString() },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
